import React, { useState } from 'react'
import { NavLink } from 'react-router-dom'
import footerbg from '../assets/images/ftr-bg.webp'

// import JobApplicationForm from './Job/JobApplicationForm.js';

const Footer = () => {

  const currentYear = new Date().getFullYear();

  const gotoTop = ()=>{
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }


  // const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div>
      {/* FOOTER START */}
      <footer className="footer-light ftr-light-with-bg site-bg-cover" style={{position:'relative'}}>
       <img
        src={footerbg}
        fetchPriority="auto"
        alt="footer background image"
        style={{
          position: 'absolute', top: 0, left: 0,
          width: '100%', height: '100%',
          objectFit: 'cover', zIndex: 0
        }}/>
        <div className="container" style={{position: 'relative', zIndex: 1}}>
          {/* FOOTER BLOCKES START */}
          <div className="footer-top">
            <div className="row">
              <div className="col-lg-3 col-md-12">
                <div className="widget widget_about">
                  <div className="logo-footer clearfix">
                    <NavLink to='/'><img src="/images/ange_gulf_logo.png" width='110px' aria-label="Visit our Home page" alt="Angel gulf" /></NavLink>
                  </div>
              <p style={{fontSize:'14px'}}>The Easiest Way to get your new Job in Gulf.</p>
                  <ul className="ftr-list">
                    <li><p><span>Address :</span>716, Master Mind 5, Near Lake View III Apt, Royal Palms, Aarey Colony, Goregaon East, Mumbai - 65 </p></li>
                    <li><p><span>Email :</span><a href='mailto:info@angelgulfjobs.com'>info@angelgulfjobs.com</a></p></li>
                    <li><p><span>WhatsApp channel :</span><a href='https://whatsapp.com/channel/0029Va9inuu6xCSXEKgRio1A' target='blank' >Join our WhatsApp </a></p></li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-9 col-md-12">
                <div className="row">
                  <div className="col-lg-3 col-md-6 col-sm-6">
                    <div className="widget widget_services ftr-list-center">
                      <h3 className="widget-title">Useful Links</h3>
                      <ul>
                        <li><NavLink to='/' onClick={gotoTop}>Home</NavLink></li>
                        <li><NavLink to='/industries' onClick={gotoTop} target='_blank'>Industries</NavLink></li>
                        <li><NavLink to='/articles' onClick={gotoTop} target='_blank'>Articles of Interest</NavLink></li>
                        <li><NavLink to='/resources' onClick={gotoTop} target='_blank'>Resources</NavLink></li>
                        <li><NavLink to='/blogs' onClick={gotoTop} target='_blank' rel='noopener noreferrer'>Blog</NavLink></li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-6">
                    <div className="widget widget_services ftr-list-center">
                      <h3 className="widget-title">Quick Links</h3>
                      <ul>
                        <li><NavLink to='/about-us' onClick={gotoTop} target='_blank'>About us</NavLink></li>
                        <li><NavLink to="/job-list" onClick={gotoTop} target='_blank'>Current Openings</NavLink></li>
                        <li><NavLink to="/apply-job/general" target="_blank">Post Your Resume</NavLink></li>
                        <li><NavLink to="/job-list" onClick={gotoTop} target='_blank'>Careers</NavLink></li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-6">
                    <div className="widget widget_services ftr-list-center">
                      <h3 className="widget-title">Helpful Links</h3>
                      <ul>
                        <li><NavLink to='/contact-us' onClick={gotoTop} target='_blank'>Contact us</NavLink></li>
                        <li><NavLink to="/recruitment-procedure" onClick={gotoTop} target='_blank'>Recruitment Procedure</NavLink></li>
                        <li><NavLink to='/terms-of-use' onClick={gotoTop} target='_blank'>Terms of use</NavLink></li>
                        <li><NavLink to='/news' onClick={gotoTop} target='_blank'>News</NavLink></li>
                        <li><NavLink to='/press-release/gulf-portal-launch' onClick={gotoTop} target='_blank'>Press Release</NavLink></li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 col-sm-6">
                    <div className="widget widget_services ftr-list-center">
                      <h3 className="widget-title">Our Services</h3>
                      <ul>
                        <li><NavLink to='/visa' onClick={gotoTop} target='_blank'>Visa Services</NavLink></li>
                        <li><NavLink to='/authentication' onClick={gotoTop} target='_blank'>Authentication</NavLink></li>
                        <li><NavLink to="/gamca-medical-centre" onClick={gotoTop} target='_blank'>Medical Centres</NavLink></li>
                        <li><NavLink to='/skill-test-centres' onClick={gotoTop} target='_blank'>Skill Test Centers</NavLink></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* FOOTER COPYRIGHT */}
          <div className="footer-bottom">
            <div className="footer-bottom-info">
              <div className="footer-copy-right">
                <span className="copyrights-text">Copyright © {currentYear} Angel Gulf Jobs. All rights reserved - Gulf Job Consultants, Gulf Visa Consultants, Gulf Recruitment Agency.</span>
              </div>
              <ul className="social-icons">
                <li><a href="https://www.facebook.com/angelgulfjobs/" rel="noopener noreferrer"   className="fab fa-facebook-f" aria-label="Visit our Facebook page" target='_blank'/></li>
                <li><a href="https://x.com/angelgulfjobs" className="fab fa-twitter" rel="noopener noreferrer"  aria-label="Visit our X (Twitter) page" target='_blank'/></li>
                <li><a href="https://www.instagram.com/angelgulfjobs/" rel="noopener noreferrer"  className="fab fa-instagram" aria-label="Visit our Instagram page" target='_blank'/></li>
                <li><a href="https://www.youtube.com/@ANGELGULFJOBS" rel="noopener noreferrer"  className="fab fa-youtube" aria-label="Visit our YouTube channel" target='_blank' /></li>
                <li><a href="https://www.linkedin.com/company/angel-gulf-jobs-for-you" rel="noopener noreferrer"  className="fab fa-linkedin" aria-label="Visit our LinkedIn page" target='_blank'/></li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
      {/* FOOTER END */}
      {/* BUTTON TOP START */}
      <button className="scroltop"><span className="fa fa-angle-up  relative" id="btn-vibrate" /></button>
      {/*Model Popup Section Start*/}
      {/*Signup popup */}
      <div className="modal fade twm-sign-up" id="sign_up_popup" aria-hidden="true" aria-labelledby="sign_up_popupLabel" tabIndex={-1}>
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <form>
              <div className="modal-header">
                <h2 className="modal-title" id="sign_up_popupLabel">Sign Up</h2>
                <p>Sign Up and get access to all the features of Jobzilla</p>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
              </div>
              <div className="modal-body">
                <div className="twm-tabs-style-2">
                  <ul className="nav nav-tabs" id="myTab" role="tablist">
                    {/*Signup Candidate*/}
                    <li className="nav-item" role="presentation">
                      <button className="nav-link active" data-bs-toggle="tab" data-bs-target="#sign-candidate" type="button"><i className="fas fa-user-tie" />Candidate</button>
                    </li>
                    {/*Signup Employer*/}
                    <li className="nav-item" role="presentation">
                      <button className="nav-link" data-bs-toggle="tab" data-bs-target="#sign-Employer" type="button"><i className="fas fa-building" />Employer</button>
                    </li>
                  </ul>
                  <div className="tab-content" id="myTabContent">
                    {/*Signup Candidate Content*/}
                    <div className="tab-pane fade show active" id="sign-candidate">
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="form-group mb-3">
                            <input name="username" type="text" required className="form-control" placeholder="Usearname*" />
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="form-group mb-3">
                            <input name="email" type="text" className="form-control" required placeholder="Password*" />
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="form-group mb-3">
                            <input name="phone" type="text" className="form-control" required placeholder="Email*" />
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="form-group mb-3">
                            <input name="phone" type="text" className="form-control" required placeholder="Phone*" />
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="form-group mb-3">
                            <div className=" form-check">
                              <input type="checkbox" className="form-check-input" id="agree1" />
                              <label className="form-check-label" htmlFor="agree1">I agree to the <NavLink href="">Terms and conditions</NavLink></label>
                              <p>Already registered?
                                <button className="twm-backto-login" data-bs-target="#sign_up_popup2" data-bs-toggle="modal" data-bs-dismiss="modal">Log in here</button>
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <button type="submit" className="site-button">Sign Up</button>
                        </div>
                      </div>
                    </div>
                    {/*Signup Employer Content*/}
                    <div className="tab-pane fade" id="sign-Employer">
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="form-group mb-3">
                            <input name="username" type="text" required className="form-control" placeholder="Usearname*" />
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="form-group mb-3">
                            <input name="email" type="text" className="form-control" required placeholder="Password*" />
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="form-group mb-3">
                            <input name="phone" type="text" className="form-control" required placeholder="Email*" />
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="form-group mb-3">
                            <input name="phone" type="text" className="form-control" required placeholder="Phone*" />
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="form-group mb-3">
                            <div className=" form-check">
                              <input type="checkbox" className="form-check-input" id="agree2" />
                              <label className="form-check-label" htmlFor="agree2">I agree to the <NavLink to="">Terms and conditions</NavLink></label>
                              <p>Already registered?
                                <button className="twm-backto-login" data-bs-target="#sign_up_popup2" data-bs-toggle="modal" data-bs-dismiss="modal">Log in here</button>
                              </p>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <button type="submit" className="site-button">Sign Up</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <span className="modal-f-title">Login or Sign up with</span>
                <ul className="twm-modal-social">
                  <li><NavLink to="https://www.facebook.com/angelgulfjobs/" className="facebook-clr"><i className="fab fa-facebook-f" /></NavLink></li>
                  <li><NavLink to="jhttps://x.com/angelgulfjobs" className="twitter-clr"><i className="fab fa-twitter" /></NavLink></li>
                  <li><NavLink to="https://www.instagram.com/angelgulfjobs/" className="linkedin-clr"><i className="fab fa-linkedin-in" /></NavLink></li>
                  <li><NavLink to="https://www.youtube.com/channel/UC2ywUMh9xqwpimGEQ-UMgcQ?view_as=subscriber" className="google-clr"><i className="fab fa-google" /></NavLink></li>
                  <li><NavLink to="https://www.linkedin.com/company/angel-gulf-jobs-for-you" className="fab fa-linkedin" target='_blank'></NavLink></li>

                </ul>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/*Login popup */}
      <div className="modal fade twm-sign-up" id="sign_up_popup2" aria-hidden="true" aria-labelledby="sign_up_popupLabel2" tabIndex={-1}>
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <form>
              <div className="modal-header">
                <h2 className="modal-title" id="sign_up_popupLabel2">Login</h2>
                <p>Login and get access to all the features of Jobzilla</p>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
              </div>
              <div className="modal-body">
                <div className="twm-tabs-style-2">
                  <ul className="nav nav-tabs" id="myTab2" role="tablist">
                    {/*Login Candidate*/}
                    <li className="nav-item">
                      <button className="nav-link active" data-bs-toggle="tab" data-bs-target="#login-candidate" type="button"><i className="fas fa-user-tie" />Candidate</button>
                    </li>
                    {/*Login Employer*/}
                    <li className="nav-item">
                      <button className="nav-link" data-bs-toggle="tab" data-bs-target="#login-Employer" type="button"><i className="fas fa-building" />Employer</button>
                    </li>
                  </ul>
                  <div className="tab-content" id="myTab2Content">
                    {/*Login Candidate Content*/}
                    <div className="tab-pane fade show active" id="login-candidate">
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="form-group mb-3">
                            <input name="username" type="text" required className="form-control" placeholder="Usearname*" />
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="form-group mb-3">
                            <input name="email" type="text" className="form-control" required placeholder="Password*" />
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="form-group mb-3">
                            <div className=" form-check">
                              <input type="checkbox" className="form-check-input" id="Password3" />
                              <label className="form-check-label rem-forgot" htmlFor="Password3">Remember me <NavLink href="">Forgot Password</NavLink></label>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <button type="submit" className="site-button">Log in</button>
                          <div className="mt-3 mb-3">Don't have an account ?
                            <button className="twm-backto-login" data-bs-target="#sign_up_popup" data-bs-toggle="modal" data-bs-dismiss="modal">Sign Up</button>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/*Login Employer Content*/}
                    <div className="tab-pane fade" id="login-Employer">
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="form-group mb-3">
                            <input name="username" type="text" required className="form-control" placeholder="Usearname*" />
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="form-group mb-3">
                            <input name="email" type="text" className="form-control" required placeholder="Password*" />
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="form-group mb-3">
                            <div className=" form-check">
                              <input type="checkbox" className="form-check-input" id="Password4" />
                              <label className="form-check-label rem-forgot" htmlFor="Password4">Remember me <NavLink to="">Forgot Password</NavLink></label>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <button type="submit" className="site-button">Log in</button>
                          <div className="mt-3 mb-3">Don't have an account ?
                            <button className="twm-backto-login" data-bs-target="#sign_up_popup" data-bs-toggle="modal" data-bs-dismiss="modal">Sign Up</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <span className="modal-f-title">Login or Sign up with</span>
                <ul className="twm-modal-social">
                  <li><NavLink to="https://www.facebook.com/angelgulfjobs/" className="facebook-clr" target='_blank'rel="noreferrer"><i className="fab fa-facebook-f" /></NavLink></li>
                  <li><NavLink to="https://x.com/angelgulfjobs" className="twitter-clr" target='_blank'rel="noreferrer"><i className="fab fa-twitter" /></NavLink></li>
                  <li><NavLink to="https://www.instagram.com/angelgulfjobs/" className="linkedin-clr" target='_blank'rel="noreferrer"><i className="fab fa-linkedin-in" /></NavLink></li>
                  <li><NavLink to="https://www.youtube.com/channel/UC2ywUMh9xqwpimGEQ-UMgcQ?view_as=subscriber" className="google-clr" target='_blank'rel="noreferrer"><i className="fab fa-google" /></NavLink></li>
                  <li><NavLink to="https://www.linkedin.com/company/angel-gulf-jobs-for-you" className="fab fa-linkedin" target='_blank'></NavLink></li>


                </ul>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/*Model Popup Section End*/}
    </div>

  )
}

export default Footer
